"use client";
import { FC, useEffect, useRef, useState } from "react";

type Props = {
  embedId: string;
};

export const HushlyEmbedBlock: FC<Props> = (props) => {
  const [shouldLoad, setShouldLoad] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container || shouldLoad) return;

    const loadHushlyScript = () => {
      const win = window as Window & {
        Hushly?: {
          Embed?: {
            whenReady?: (...args: unknown[]) => void;
            queue?: unknown[];
            accountId?: string;
          };
        };
        HushlyEmbed?: unknown;
      };
      const doc = document;
      const src = "https://embed-ui.hushly.com/embed.js";
      const accountId = "11616";

      const hlyEmbed = doc.querySelector("script#hub-embed");
      if (hlyEmbed) return;

      const Hushly = (win.Hushly = win.Hushly || {});
      Hushly.Embed = Hushly.Embed || {
        whenReady: function (...args: unknown[]) {
          (Hushly.Embed!.queue = Hushly.Embed!.queue || []).push(args);
        },
      };
      Hushly.Embed.accountId = accountId;
      win.HushlyEmbed = win.HushlyEmbed || Hushly.Embed;

      const hws = doc.createElement("script");
      hws.id = "hub-embed";
      hws.type = "text/javascript";
      hws.async = true;
      hws.src = src;
      const node = doc.getElementsByTagName("head")[0];
      node.appendChild(hws);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setShouldLoad(true);
            loadHushlyScript();
            observer.disconnect();
          }
        });
      },
      {
        threshold: 0,
        rootMargin: "50px",
      },
    );

    observer.observe(container);
    return () => observer.disconnect();
  }, [shouldLoad]);

  return (
    <div ref={containerRef}>
      {/* @ts-expect-error Custom element */}
      <embed-stream embed-id={props.embedId}></embed-stream>
    </div>
  );
};
